import React from "react";
import TextField from "../reusable/TextInput";
import { tw } from "@careinfo/tailwind";
import PhoneNumberField from "../reusable/PhoneNumberField";
import UrlField from "../reusable/UrlField";

const ShipviaForm = (props: any) => {
  const { register, errors, control } = props;
  return (
    <div className={tw`px-4 grid grid-cols-2 gap-x-4`}>
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
      <PhoneNumberField
        control={control}
        name={"contact_number"}
        errors={errors?.contact_number}
        label={"Contact Number"}
      />
      <UrlField
        control={control}
        name="track_url"
        errors={errors?.track_url}
        register={register("track_url")}
        label="Track URL"
        placeholder="https://example.com"
      />
    </div>
  );
};

export default ShipviaForm;
